import { render, staticRenderFns } from "./openVideoClassEdit.vue?vue&type=template&id=542ba8b8&scoped=true"
import script from "./openVideoClassEdit.vue?vue&type=script&lang=js"
export * from "./openVideoClassEdit.vue?vue&type=script&lang=js"
import style0 from "./openVideoClassEdit.vue?vue&type=style&index=0&id=542ba8b8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542ba8b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('542ba8b8')) {
      api.createRecord('542ba8b8', component.options)
    } else {
      api.reload('542ba8b8', component.options)
    }
    module.hot.accept("./openVideoClassEdit.vue?vue&type=template&id=542ba8b8&scoped=true", function () {
      api.rerender('542ba8b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/webSet/video/openVideoClassEdit.vue"
export default component.exports